/**
 * @file MasterLayout.tsx
 * @module _admin/layout/MasterLayout
 * @description Provides the MasterLayout top-level layout component used to initialize and render the UTrade Admin application shell.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { reInitMenu } from '../helpers';
import { ThemeModeProvider } from '../partials';
import { Content } from './components/content';
import { FooterWrapper } from './components/footer';
import { HeaderWrapper } from './components/header';
import { ScrollTop } from './components/scroll-top';
import { Sidebar } from './components/sidebar';
import { ToolbarWrapper } from './components/toolbar';
import { PageDataProvider } from './core';
import { AutoBreadcrumbs } from './core/AutoBreadcrumbs';
import TodoSidebar from '../../app/modules/_common/components/todo-sidebar';
import AiChatSidebar from '../../app/modules/_common/components/ai-chat-sidebar';
import PeopleChat from '../../app/modules/_common/components/people-chat';
const MasterLayout = () => {
  const location = useLocation();
  useEffect(() => {
    reInitMenu();
  }, [location.key]);
  return (
    <PageDataProvider>
      <ThemeModeProvider>
        {/* <AutoBreadcrumbs /> */}
        <div
          className="d-flex flex-column flex-root app-root"
          id="kt_app_root"
        >
          <div
            className="app-page flex-column flex-column-fluid"
            id="kt_app_page"
          >
            <HeaderWrapper />
            <div
              className="app-wrapper flex-column flex-row-fluid"
              id="kt_app_wrapper"
            >
              <Sidebar />
              <div
                className="app-main flex-column flex-row-fluid"
                id="kt_app_main"
              >
                <div className="d-flex flex-column flex-column-fluid">
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>
        <ScrollTop />
        <PeopleChat />
        {/* DO NOT REMOVE */}
        {/* intentionally commented out for now, functionality is in discussion or under development. */}
        {/* <TodoSidebar />
        <AiChatSidebar />
         */}
        {/* DO NOT REMOVE */}
      </ThemeModeProvider>
    </PageDataProvider>
  );
};
export { MasterLayout };
